import { ReactNode } from 'react'

interface RichContentSectionProps {
  id: string
  title: string
  children: ReactNode
  className?: string
}

export const RichContentSection = ({
  id,
  title,
  children,
  className = 'py-14',
}: RichContentSectionProps) => (
  <section
    id={id}
    className={`w-full flex flex-col items-start gap-6 ${className}`}
  >
    <h3 className="text-gray-800 text-2xl font-bold">{title}</h3>
    {children}
  </section>
)

interface HtmlContentSectionProps {
  id: string
  title: string
  html: string
  className?: string
}

export const HtmlContentSection = ({
  id,
  title,
  html,
  className,
}: HtmlContentSectionProps) => (
  <RichContentSection id={id} title={title} className={className}>
    {/* break-words: event content is pasted in by admins and regularly
        carries a long URL, which otherwise widens the whole page. */}
    <div className="ql-snow w-full max-w-full break-words">
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  </RichContentSection>
)
